import React from 'react';

const TwitterIcon = ({ backgroundColor, iconColor, ...iconProps }) => (
  <svg
    enableBackground="new 0 0 48 48"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...{ height: 25, width: 25, ...iconProps }}
  >
    <circle cx="24" cy="24" r="24" fill={backgroundColor} />
    <path
      d="m36.8 15.4c-.9.5-2 .8-3 .9 1.1-.7 1.9-1.8 2.3-3.1-1 .6-2.1 1.1-3.4 1.4-1-1.1-2.3-1.8-3.8-1.8-2.9 0-5.3 2.5-5.3 5.7 0 .4 0 .9.1 1.3-4.4-.2-8.3-2.5-10.9-5.9-.5.8-.7 1.8-.7 2.9 0 2 .9 3.7 2.3 4.7-.9 0-1.7-.3-2.4-.7v.1c0 2.7 1.8 5 4.2 5.6-.4.1-.9.2-1.4.2-.3 0-.7 0-1-.1.7 2.3 2.6 3.9 4.9 3.9-1.8 1.5-4.1 2.4-6.5 2.4-.4 0-.8 0-1.3-.1 2.3 1.6 5.1 2.6 8.1 2.6 9.7 0 15-8.6 15-16.1 0-.2 0-.5 0-.7 1.2-1 2.1-2 2.8-3.2z"
      fill={iconColor}
    />
  </svg>
);

export default TwitterIcon;
